export class CBReactMethods {

}

export class CBMethods {
    
}
export class CBStudentMethods {
    
}

export class CBInstructorMethods {
    
}
